export enum TemplateAssignmentType {
  Event = 1,
  Campaign = 2
}
